import Button from '../../commons/button'
import icAddSquare from '../../../assets/images/id-add-square.svg'
import icTrashGray from '../../../assets/images/ic-trash-01-gray.svg'
import icTrashRed from '../../../assets/images/ic-trash-01-red.svg'
import icArchive from '../../../assets/images/ic-archive.svg'
import Table from '../../commons/table'
import Search from '../../commons/search'
import Filter from '../../commons/filter'
import Toast from '../../commons/toast'
import DeleteModal from '../../commons/delete-modal'
import { TABLE_SOP } from '../../../configs/sop/configTableSop'
import { SopPreviewDrawer } from './SopPreviewDrawer'
import { SOP_FILTER_QUERY_PARAMS } from '../../../configs/sop/configTableSop'
import ViewList from 'components/commons/view-list'
import { StandardModal } from 'components/commons/StandardModal'

export const SopList = ({
    dataList,
    isLoading,
    query,
    onChangeQuery,
    onClickItemHandler,
    onCreateHandler,
    modal,
    setModal,
    isDeleting,
    isArchiving,
    onDelete,
    onArchive,
    toast,
    clearToast,
    selectedItems,
    onSelectItem,
    onBulkArchive,
    onBulkDelete,
    previewData,
    // Filter props
    showFilter,
    onShowFilter,
    onCloseFilter,
    filterList,
    activeFilter,
    onSelectFilter,
    filter,
    filterCount,
    filterOptions,
    onChangeFilterOption,
    onChangeFilterSelect,
    onSubmitFilter,
    onClearFilter,
}) => {
    const hasSelectedDraft = selectedItems?.some((item) => item?.status === 'draft')
    const hasSelectedActive = selectedItems?.some((item) => item?.status === 'active')

    return (
        <div className='flex flex-col'>
            <div className='flex flex-row justify-between px-6 py-4 gap-3'>
                <div className='flex flex-row space-x-3'>
                    <Search value={query?.search} onSearch={(search) => onChangeQuery({ page: 1, search })} />
                    <Filter
                        show={showFilter}
                        onShow={onShowFilter}
                        onClose={onCloseFilter}
                        queryParams={SOP_FILTER_QUERY_PARAMS}
                        filterList={filterList}
                        onSelectFilter={onSelectFilter}
                        activeFilter={activeFilter}
                        filter={filter}
                        filterCount={filterCount}
                        options={filterOptions}
                        onChangeOption={onChangeFilterOption}
                        onChangeSelect={onChangeFilterSelect}
                        onSubmitFilter={onSubmitFilter}
                        onClearFilter={onClearFilter}
                    />
                    <ViewList
                        show={modal?.limit}
                        onShow={() => setModal((prev) => ({ ...prev, limit: true }))}
                        onClose={() => setModal((prev) => ({ ...prev, limit: false }))}
                        value={query?.limit}
                        onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                    />
                </div>
                <div className='flex flex-row space-x-3'>
                    <Button
                        title={`Delete (${selectedItems.filter((i) => i?.status === 'draft').length})`}
                        type='danger'
                        icon={hasSelectedDraft ? icTrashRed : icTrashGray}
                        onClick={onBulkDelete}
                        disabled={!hasSelectedDraft}
                    />
                    <Button
                        title={`Archive (${selectedItems.filter((i) => i?.status === 'active').length})`}
                        type='outline'
                        onClick={onBulkArchive}
                        disabled={!hasSelectedActive}
                    />

                    <Button title='Create SOP' icon={icAddSquare} onClick={onCreateHandler} />
                </div>
            </div>
            <Table
                className='my-3'
                name={TABLE_SOP.name}
                columns={TABLE_SOP.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickItem={(val) => onClickItemHandler(val)}
                onSelectItem={onSelectItem}
                loading={isLoading}
            />
            <SopPreviewDrawer
                visibility={modal?.preview}
                onHide={() => setModal((prev) => ({ ...prev, preview: false }))}
                data={previewData}
            />
            <DeleteModal
                show={modal?.delete}
                onHide={() => setModal((prev) => ({ ...prev, delete: false }))}
                onDelete={onDelete}
                isLoading={isDeleting}
                text='Apakah anda yakin ingin menghapus SOP ini?'
            />
            <StandardModal
                icon={icArchive}
                show={modal?.archive}
                onHide={() => setModal((prev) => ({ ...prev, archive: false }))}
                onSubmit={onArchive}
                isLoading={isArchiving}
                confirmText='Archive'
                text='Apakah anda yakin ingin mengarsipkan SOP ini?'
            />
            <Toast show={toast?.isShowToast} message={toast?.message} onClose={() => clearToast()} />
        </div>
    )
}
